import React from "react";
import { styled } from "@mui/system";
import { Typography, Button } from "@mui/material";
// import Header from "../components/Header";
import FactsSection from "../components/FactsSection";
import { buttonBg, secondaryBg } from "../constants/colors";
import { primaryTxt } from "../constants/colors";

const Header = styled("h2")({
  fontFamily: "Roboto Slab",
  fontWeight: "600",
  marginTop: "30px",
  marginBottom: "40px",
  fontSize: "3rem",
  marginLeft: "10px",
  paddingLeft: "24px",
  color: "white",
});

const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  //   backgroundColor: secondaryBg,
  height: "100%",
  // alignItems: "center",
});

const Text = styled(Typography)(({ theme }) => ({
  fontFamily: "Roboto Slab",
  color: primaryTxt,
  fontWeight: "300",
  padding: "0px 40px",
  marginBottom: "20px",
  [theme.breakpoints.down("sm")]: {
    padding: "0.2em",
  },
}));

const Rates = styled(Typography)(({ theme }) => ({
  fontFamily: "Roboto Slab",
  color: primaryTxt,
  fontSize: "18px",
  fontWeight: "400",
  // padding: "0px 40px",
  // marginBottom: "8px",
  // [theme.breakpoints.down("sm")]: {
  //   padding: "0.2em",
  // },
}));

const ContactDiv = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignSelf: "center",
  marginBottom: "40px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

const ContactButton = styled(Button)({
  backgroundColor: "white",
  color: buttonBg,
  display: "flex",
  justifyContent: "center",
  width: "280px",
  margin: "10px",
  "&:hover": {
    backgroundColor: "#45a049",
  },
});

export default function Contact() {
  return (
    <>
      <Container>
        <Header id={"contact"}>Contact & Rates</Header>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "0px 40px",
            marginBottom: "24px",
          }}
        >
          <Rates>$450/night</Rates>
          <Rates>3 night minimum</Rates>
          <Rates>12% rental tax</Rates>
          <Rates>$180 cleaning fee</Rates>
        </div>
        <Text>
          Thank you for your interest in the Downieville River House.
          Please contact me for reservations, or if you have any questions.
          Thanks! -Nancy Taylor-
        </Text>
        <ContactDiv>
          <ContactButton variant="contained" href="tel:+4152464212">
            Call/Text: 415-246-4212
          </ContactButton>
          <ContactButton
            variant="contained"
            href="mailto:nancyjoanntaylor@gmail.com"
          >
            nancyjoanntaylor@gmail.com
          </ContactButton>
        </ContactDiv>
      </Container>
    </>
  );
}
